import React, { useCallback, useMemo, useState } from 'react';

import { Button, notification } from 'antd';
import { getIntl, history } from 'umi';

const ToastCtxButton = ({ context = null, data = null, route }) => {
  const intl = getIntl();
  const [loading, setLoading] = useState(false);

  const onFinish = useCallback(() => {
    history.replace(`${route.pathname}${route.search}`);
  }, [route]);

  const byContext = useMemo(() => {
    if (!context || !data) return;

    const { company, environment } = data;
    const nextContext = {
      company: {
        type: 'userContext/changeCompany',
        payload: {
          context,
          id: company?.id,
          accessId: company?.accessUserId,
          environmentId: environment?.id,
          onFinish,
        },
      },
      environment: {
        type: 'userContext/changeEnvironment',
        payload: {
          context,
          id: environment?.id,
          onFinish,
        },
      },
    };

    return nextContext[context];
  }, [context, data, onFinish]);

  const handleCtxChange = useCallback(async () => {
    if (!byContext) return;

    setLoading(true);

    await window.dispatch?.(byContext);
    notification.close('glob-notify');

    setLoading(false);
  }, [byContext]);

  return (
    <Button loading={!!loading} disabled={!!loading} type="primary" onClick={handleCtxChange}>
      {context === 'company' && intl.formatMessage({ id: 'global.button.company' })}
      {context === 'environment' && intl.formatMessage({ id: 'global.button.environment' })}
    </Button>
  );
};

export default ToastCtxButton;
